"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var task_1 = require("@alife/task");
var service_1 = require("./service");
var config_1 = require("../config");
var FormItem = next_1.Form.Item;
var formItemLayout = {
    labelCol: {
        fixedSpan: 6,
    },
    wrapperCol: {
        span: 10,
    },
};
var InfoConfirm = function (props) {
    var _a = props.name, name = _a === void 0 ? "" : _a, _b = props.idCard, idCard = _b === void 0 ? "" : _b, _c = props.company, company = _c === void 0 ? [] : _c, _d = props.cardType, cardType = _d === void 0 ? "" : _d, selectOpts = props.selectOpts;
    var isLegal = task_1.Util.isLegal();
    var _e = react_1.useState(true), checked = _e[0], setChecked = _e[1];
    var _f = react_1.useState(""), companyId = _f[0], setcompanyId = _f[1];
    var _g = react_1.useState(""), companyName = _g[0], setCompanyName = _g[1];
    react_1.useEffect(function () {
        if (company && company[0]) {
            setcompanyId(company[0].value);
            setCompanyName(company[0].label);
        }
    }, [company]);
    var onChange = function (value) {
        setcompanyId(value);
    };
    /**
     * 跳转事项链接
     */
    var goReceptLink = function () {
        if (props.goto) {
            window.location.href = props.goto;
        }
    };
    /**
     * 身份为个人时，是否需要补全用户信息
     * @param isNeedComplete 是否需要补全用户信息
     */
    var completePersonInfo = function (isNeedComplete) {
        if (isNeedComplete) {
            props.setStatus(config_1.TASKTYPE.register);
        }
        else {
            goReceptLink();
        }
    };
    var loginSuccessCB = function (data) {
        var needAddition = data && data.needAddition;
        // 法人：具体事项链接，个人: 是否需要完善信息
        isLegal ? goReceptLink() : completePersonInfo(needAddition === "true");
    };
    var onConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var params, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!checked) {
                        next_1.Message.warning("请确认是本人办理本次业务!");
                        return [2 /*return*/];
                    }
                    params = {
                        loginType: "offline",
                        identifier: idCard,
                        credential: {
                            userId: companyId,
                            loginType: "1",
                            bizKey: getValueByKeyInArray({
                                array: company,
                                keyName: "value",
                                key: companyId,
                                target: "bizKey",
                            }),
                        },
                    };
                    if (!isLegal) {
                        params.credential.idType = cardType;
                        params.credential.userName = name;
                        params.credential.idNum = idCard;
                    }
                    return [4 /*yield*/, service_1.doLogin(params, loginSuccessCB, null)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getValueByKeyInArray = function (data) {
        var array = data.array, key = data.key, _a = data.keyName, keyName = _a === void 0 ? "key" : _a, target = data.target;
        var activeArray = array.filter(function (item) { return item[keyName] === key; });
        return activeArray[0] && activeArray[0][target];
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "formLable" }, "\u8BF7\u786E\u8BA4\u529E\u4E8B\u4EBA\u662F\u5426\u4E3A\u8BC1\u4EF6\u672C\u4EBA"),
        React.createElement(next_1.Form, __assign({}, formItemLayout, { className: "infoContent" }),
            React.createElement(FormItem, { label: "\u59D3\u540D\uFF1A" },
                React.createElement("p", { className: "itemLable" }, name)),
            React.createElement(FormItem, { label: "\u8BC1\u4EF6\u53F7\uFF1A" },
                React.createElement("p", { className: "itemLable" }, idCard)),
            isLegal ? (React.createElement(FormItem, { label: "\u516C\u53F8\uFF1A" }, company && company.length > 1 ? (React.createElement(next_1.Select, { className: "itemLable", dataSource: company, value: companyId, onChange: onChange })) : (React.createElement("span", { className: "next-form-text-align" }, companyName)))) : (React.createElement(FormItem, { label: "\u8BC1\u4EF6\u7C7B\u578B\uFF1A" },
                React.createElement("p", { className: "itemLable" }, getValueByKeyInArray({
                    array: selectOpts,
                    keyName: "value",
                    key: cardType,
                    target: "label",
                }))))),
        React.createElement("div", { className: "infoItem" },
            React.createElement(next_1.Checkbox, { name: "baseAgreement", checked: checked, onChange: function (checked) {
                    setChecked(checked);
                } }, "\u786E\u8BA4\u662F\u672C\u4EBA\u529E\u7406\u672C\u6B21\u4E1A\u52A1")),
        React.createElement("div", { className: "infoItem" },
            React.createElement(next_1.Button, { className: "infoBtn", type: "primary", onClick: onConfirm }, "\u786E\u8BA4"))));
};
exports.default = InfoConfirm;
